import { StopPointOfInterest } from 'generated/mos/org/getty/audio'
import { TranslatableStringValue, TranslatableMediaValue } from 'generated/mos/translatable'

import { Schema } from 'helpers/schema'
import { createTranslatableMediaValue, getTranslatableValue, setTranslatableValue, createTranslatableStringValue, } from 'helpers/translatables'

const isNonEmpty = (value: any) => {
  if (typeof value === 'string' && (!value || !value.trim().length) || typeof value === 'object' && !Object.keys(value).length) {
    return false
  }

  return value
}

export const pointOfInterestSchema: Schema<StopPointOfInterest.Entity> = {
  teaserText: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  content: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  additionalInfo: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  deepDiveLabel: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  deepDiveContextLabel: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  deepDiveUrl: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
  audio: {
    read: (value, language) => getTranslatableValue(value, language),
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableMediaValue(value as any, language),
      existingValue ?
        existingValue as TranslatableMediaValue.Entity :
        TranslatableMediaValue.defaults,
    ) as any as TranslatableMediaValue.Entity : undefined,
  },
  headerText: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
}
